import React, { Fragment } from 'react';

const AboutMentor = () => {
  return (
    <Fragment>
      <div className="stream-section-container">
        <div className="padding-container">
          <div className="title-container-info">
            <div className="border-alt red">
              <p className="online-title-alt red">About Me</p>
            </div>
          </div>
          <p className="stream-desc-paragraph">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
            asperiores, rem autem consectetur minus sit, in consequuntur magnam
            alias, temporibus voluptatum reiciendis omnis ab earum modi
            laudantium ex velit eaque?Ratione labore voluptate sunt odit, neque
            illum iste corporis quaerat laudantium voluptates aliquid voluptas
            minima ducimus nam blanditiis expedita mollitia vero accusamus
            distinctio! Debitis molestias eos doloremque officiis quibusdam
            mollitia!
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default AboutMentor;
